<template>
  <div class="max-w-7xl mx-auto mt-8 bg-white p-6 rounded-xl shadow-md">
    <!-- Header -->
    <div class="mb-6">
      <h2 class="text-2xl font-bold text-gray-800 mb-2 flex items-center gap-2">
        User Feedback for {{ user.first_name }} {{ user.last_name }}
        <BaseInfoIcon :text="ERKLAERUNG.benutzerFeedback" label="User Feedback" />
      </h2>
    </div>

    <!-- Tabs -->
    <div class="mb-4 border-b border-gray-200">
      <nav class="-mb-px flex space-x-4">
        <button
          @click="activeTab = 'live'"
          :class="tabClass('live')"
        >
          Live Sessions
        </button>
        <button
          @click="activeTab = 'async'"
          :class="tabClass('async')"
        >
          Async Sessions
        </button>
      </nav>
    </div>

    <!-- Tab Content -->
    <div>
      <LiveSessionsFeedback v-if="activeTab === 'live'" />
      <AsyncSessionsFeedback v-if="activeTab === 'async'" />
    </div>
  </div>
</template>

<script>
import LiveSessionsFeedback from "./LiveSessionsFeedback.vue";
import AsyncSessionsFeedback from "./AsyncSessionsFeedback.vue";
import BaseInfoIcon from "@/BaseComponents/BaseInfoIcon.vue";
import { ERKLAERUNG } from "@/async-sessions/erklaerungen";
import { getCurrentUser } from "@/api/users";

export default {
  components: { LiveSessionsFeedback, AsyncSessionsFeedback, BaseInfoIcon },
  data() {
    return {
      ERKLAERUNG,
      activeTab: "live",
      user: {},
    };
  },
  watch: {
    activeTab(newTab) {
      this.$router.replace({ query: { ...this.$route.query, tab: newTab } });
    },
  },
  mounted() {
    this.activeTab = this.$route.query.tab || "live";
    this.fetchCurrentUser();
  },
  methods: {
    tabClass(tab) {
      return [
        "px-3 py-2 font-medium text-sm rounded-t",
        this.activeTab === tab
          ? "border-b-2 border-indigo-600 text-indigo-600"
          : "text-gray-500 hover:text-gray-700"
      ];
    },
    async fetchCurrentUser() {
      try {
        const response = await getCurrentUser();
        this.user = response.data;
      } catch (error) {
        console.error("Failed to fetch current user:", error);
      }
    }
  }
};
</script>
